import { Landing } from "./routes/Landing";

export function App() {
  return <Landing />;
}
